export const MenuList = [
    // Tableau de bord
    {
        title: 'Tableau De Bord',	
        classsChange: 'mm-collapse',		
        iconStyle: <i className="fa fa-home"></i>,
        to: 'dashboard',
    },
    
    // Annonces
    {
        title: 'Annonces',
        classChange: "mm-collapse",
        iconStyle: <i className="fa fa-briefcase"></i>,
        content: [
            {
                title: 'Liste',
                to: 'job-list',
                iconStyle: <i className="fa fa-list"></i>
            },
            {
                title: 'Catégories',
                to: 'categories',
                iconStyle: <i className="fa fa-tags"></i>
            },
            {
                title: 'Entreprises',
                to: 'companies',
                iconStyle: <i className="fa fa-building"></i>
            },
            {
                title: 'Types D\'annonce',
                to: 'job-types',
                iconStyle: <i className="fa fa-layer-group"></i>
            },
            {
                title: 'Type De Salaire',
                to: 'salary-types',
                iconStyle: <i className="fa fa-money-bill"></i>
            },
        ],
    },
    
    // Utilisateurs
    {
        title: 'Utilisateurs',
        classChange: "mm-collapse",
        iconStyle: <i className="fa fa-users"></i>,
        content: [
            {
                title: 'Liste',
                to: 'users-list',
                iconStyle: <i className="fa fa-user"></i>
            },
            {
                title: 'Rôles',
                to: 'user-roles',
                iconStyle: <i className="fa fa-user-tag"></i>
            },
            {
                title: 'Permissions',
                to: 'user-permissions',
                iconStyle: <i className="fa fa-shield-alt"></i>
            },
        ],
    },
    
    // Paiements
    {
        title: 'Paiements',
        classChange: "mm-collapse",
        iconStyle: <i className="fa fa-credit-card"></i>,
        content: [
            {
                title: 'Promotions',
                to: 'promotions',
                iconStyle: <i className="fa fa-percentage"></i>
            },
            {
                title: 'Abonnements',
                to: 'subscriptions',
                iconStyle: <i className="fa fa-crown"></i>
            },
        ],
    },
    
    // Pages
    {
        title: 'Pages',
        classChange: "mm-collapse",
        iconStyle: <i className="fa fa-file-alt"></i>,
        content: [
            {
                title: 'À propos',
                to: 'page-about',
                iconStyle: <i className="fa fa-info-circle"></i>
            },
            {
                title: 'Contact',
                to: 'page-contact',
                iconStyle: <i className="fa fa-envelope"></i>
            },
            {
                title: 'FAQ',
                to: 'page-faq',
                iconStyle: <i className="fa fa-question-circle"></i>
            },
        ],
    },
    
    // Configuration
    {
        title: 'Configuration',
        classsChange: 'mm-collapse',
        iconStyle: <i className="fa fa-cog"></i>,
        content: [
            {
                title: 'Paramètres',
                to: 'settings-general',
                iconStyle: <i className="fa fa-sliders-h"></i>
            },
            {
                title: 'Langues',
                to: 'languages',
                iconStyle: <i className="fa fa-language"></i>
            },
            {
                title: 'Plugins',
                to: 'plugins',
                iconStyle: <i className="fa fa-plug"></i>
            },
            {
                title: 'Ads (Publicités)',
                to: 'ads',
                iconStyle: <i className="fa fa-ad"></i>
            },
        ],
    },
    
    // Vider Le Cache
    {
        title: 'Vider Le Cache',	
        classsChange: 'mm-collapse',		
        iconStyle: <i className="fa fa-sync"></i>,
        to: 'clear-cache',
    },
]